// src/common/hooks/useDisplayPrice.ts
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCurrentCluster } from "../../store/slices/currentClusterSlice";
import { selectForceStores } from "../../store/slices/storeListSlice";
import { PriceItemInterface } from "../types/types";

export const useDisplayPrice = () => {
  const cluster = useSelector(selectCurrentCluster);
  const forceStore = cluster?.forceStore ?? false;
  const onePrice = cluster?.onePrice ?? false;
  const selectedStoreIds = useSelector(selectForceStores);

  return useMemo(() => {
    return (prices: PriceItemInterface[] | undefined): number => {
      if (!prices || prices.length === 0) return 0;

      // Если включен forceStore и onePrice — берем первую цену
      if (forceStore && onePrice) {
        return prices[0]?.price ?? 0;
      }

      // Если включен forceStore, но onePrice выключен — берем цену для выбранного магазина
      if (forceStore && selectedStoreIds && selectedStoreIds.length > 0) {
        const selectedStoreId = selectedStoreIds[0];
        const storePrice = prices.find((p) => p.storeId === selectedStoreId);
        if (storePrice) return storePrice.price;
        return 0;
      }

      // Если forceStore выключен — берем первую цену
      return prices[0]?.price ?? 0;
    };
  }, [forceStore, onePrice, selectedStoreIds]);
};
